import { ChevronLeft, ChevronRight, ChevronsLeft } from '@gravity-ui/icons';
import { PaginationItem } from '@mui/material';
import type { MRT_RowData, MRT_TableOptions } from 'material-react-table';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { Localization_RU } from './localization';
import type { TableArgs } from './types';

import { ReactComponent as ArrowsDownFilter } from 'assets/icons/arrow-down-filter.svg';
import { ReactComponent as ArrowsFilter } from 'assets/icons/arrows-filter.svg';

/** Обертка над MaterialReactTable */
export const DataTable = <T extends MRT_RowData>({ options }: TableArgs<T>) => {
	const defaultTableOptions: Omit<MRT_TableOptions<T>, 'columns' | 'data'> = {
		icons: {
			SyncAltIcon: (props: any) => <ArrowsFilter {...props} />,
			ArrowDownwardIcon: (props: any) => <ArrowsDownFilter {...props} />,
		},
		//enable some features
		enableTopToolbar: false,
		enableRowActions: true,
		enableColumnActions: false, // отключить доп меню колонок
		enableRowSelection: true,
		positionActionsColumn: 'last',
		enableFilters: false, // доп фильтрация
		enableColumnOrdering: true,
		enableColumnDragging: false,
		enableGlobalFilter: false, //глобальная фильтрация
		localization: Localization_RU, //локализация
		enableStickyHeader: true, //липкий header
		enableStickyFooter: false, // липкий footer
		enableFullScreenToggle: false, // скрыть кнопку "на весь экран"
		positionPagination: 'both',
		positionToolbarAlertBanner: 'bottom',
		initialState: {
			density: 'compact',
			pagination: {
				pageIndex: 0,
				pageSize: 20,
			},
		},
		muiPaginationProps: {
			boundaryCount: 3,
			rowsPerPageOptions: [20, 40, 60, 80, 100],
			shape: 'rounded',
			variant: 'text',
			showLastButton: false,
			sx: {
				//left: '0px',
				//position: 'absolute',
				paddingRight: '20px',
			},
			size: 'large',
			renderItem: (item) => (
				<PaginationItem slots={{ previous: ChevronLeft, next: ChevronRight, first: ChevronsLeft }} {...item} />
			),
		},
		paginationDisplayMode: 'pages',
		layoutMode: 'semantic',
		muiTableBodyCellProps: {
			sx: {
				p: '6px 8px 5px',
			},
		},
		muiTableBodyRowProps: {
			sx: {
				minHeight: '48px',
			},
		},
		muiTablePaperProps: {
			elevation: 0,
		},
	};

	const table = useMaterialReactTable({
		...defaultTableOptions,
		...options,
	});

	return <MaterialReactTable table={table} />;
};
